import { ITickerSlice } from "./tickerSlice.interface";

export const TickerSliceInitialState: ITickerSlice = {
  currentTimeUTC: new Date().toISOString(),
};
